import Model, { attr } from '@ember-data/model';

import type { Slack } from 'webapp-types';

export default class ReportDeliveryRecord extends Model {
	@attr('number') reportId!: number;
	@attr('number') timestamp!: number;
	@attr('string') title!: string;
	@attr('string') image!: string;
	@attr('number') slideCount!: number;
	@attr('string') reportUrl!: string;
	@attr('number') size!: number;
	// @attr('array', { defaultValue() { return []; } }) approvedBy!: number[];
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	recipients!: string[];
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	slackChannels!: Slack.Channels;
}
